<script>
  import cn from "classnames";

  export let element = "label";
  export let required = false;
</script>

<svelte:element
  this={element}
  {...$$restProps}
  class={cn("block font-medium", $$props.class)}
>
  <slot />
  {#if required}
    <span class="text-red-500">*</span>
  {/if}
</svelte:element>
